;(function($, window, document){
    window.ArrowButton = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, ['goToNextSection']);
            this.addEvents();
        },
        addEvents: function() {
            if(this.$el.hasClass('next-section-button')){
                this.$el.on('click', this.goToNextSection);

            }
        },
        goToNextSection: function(){
            var $parentSection = this.$el.parents('.shopify-section');
        
            var $nextSection = $parentSection.next('.index-section');
    
            if ($nextSection.length == 0) {
                return false;
            }

            $("html, body").animate({
                scrollTop: $nextSection.position().top
            });
        }
    });
}(jQuery, window, document));
